(function (win) {
  const DESIGN_WIDTH = 1920; // 设计稿宽度
  const MIN_WIDTH = 1920; // 最小屏幕宽度限制  1200
  const root = win.document.documentElement;

  function setRem() {
    // 限制最小屏幕宽度，避免小屏文字过小
    const clientWidth = Math.max(root.clientWidth, MIN_WIDTH);
    const scale = clientWidth / DESIGN_WIDTH;
    const fontSize = 192 * scale; // rootValue = 192
    root.style.fontSize = fontSize + 'px';
  }

  setRem();
  win.addEventListener('resize', setRem);
})(window);